import { render, staticRenderFns } from "./InvoicesOverview.vue?vue&type=template&id=698ba980&scoped=true&"
import script from "./InvoicesOverview.vue?vue&type=script&lang=js&"
export * from "./InvoicesOverview.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesOverview.vue?vue&type=style&index=0&id=698ba980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698ba980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
